import {ReportModel} from "@fedeltapointofsale/data-client";
import {PriceLevelAuditReportData} from "./price-level-audit-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PriceLevelAuditReportModel extends ReportModel<PriceLevelAuditReportData> {
    constructor(injector: Injector) {
        super(injector, PriceLevelAuditReportData)
    }
}
